import { createRoutine } from "redux-saga-routines";

export const confirmAnnouncementRoutine = createRoutine('CONFIRM_ANNOUNCEMENT');